module.exports = __webpack_public_path__ + "static/img/6262_phase_function_Paper_PointsHejduk_Prediction.c1c0a70.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/6262_phase_function_Paper_PointsHejduk_Prediction.png
// module id = mNKP
// module chunks = 0